import Registry from './Registry';
import { empty } from "../helpers/functions";

class Select {

  /**
   * @function
   * Getting instance of Select
   * @param {object|string} selector
   * @return {Select}
   */
  static get(selector) {

    let instance = Registry.get('Select', selector);
    if (instance)
      return instance;

    instance = new Select(selector);
    Registry.set('Select', selector, instance);

    return instance;

  }

  /**
   * @constructor
   * @param {object|string} selector
   * @return {Select} Select object
   */
  constructor(selector) {

    this.selector = selector;
    if (typeof selector === 'string')
      this.obj = $(this.selector);
    else
      this.obj = this.selector;

    this.select = this.obj.find('select:not([multiple])');
    this.multiSelect = this.obj.find('select[multiple]');
    this.onchanges = [];
    this.width = this.obj.width();
    this.i();
    return this;
  }

  /**
   * @function
   * Initialize Select
   * @return {Select}
   */
  i() {
    if (this.obj.hasClass('initialized'))
      return;

    this.initSelect();
    this.initMultiSelect();
    this.addEvents();
    this.addClasses();
    return this;
  }


  /**
   * @function
   * Rerender all selects's in Select object
   * @return {Select}
   */
  updateAll() {
    const self = this;
    this.select.each(function () {
      self.update($(this));
    });
    this.multiSelect.each(function () {
      self.update($(this));
    });
    return this;
  }

  /**
   * @function
   * Rerender single select
   * @param {jQuery} select
   * @return {Select}
   */
  update(select) {
    this.makeList(select, !!select.attr('multiple'));
    this.addClasses();
    this.checkSelectVal(select.parent().find('.select-list'));
    select.change();
    return this;
  }

  /**
   * @function
   * Render HTML of all Single select
   * @return {Select|undefined}
   */
  initSelect() {
    if (!this.select.length)
      return;

    const self = this;

    self.select.each(function () {
      self.makeList($(this), false);
    });
    return this;
  }

  /**
   * @function
   * Render HTML of all Multiple select
   * @return {Select|undefined}
   */
  initMultiSelect() {
    if (!this.multiSelect.length)
      return;

    const self = this;

    self.multiSelect.each(function () {
      self.makeList($(this), true)
    });
    return this;
  }

  /**
   * @function
   * Make HTML for select
   * @param {jQuery} item
   * @param {boolean} multi is Select multiple
   * @return {Select}
   */
  makeList(item, multi) {
    item.parent().find('.select__arrow').remove();
    let selectClass = (item.data('simple') === '1') ? ' simple' : '';

    if (item.attr('select-class')) {
      selectClass += " " + item.attr('select-class');
    }

    let head = `<div class="select-head${selectClass}" 
            data-text="${item.parent().find('legend').text()}" ${(item.attr('disabled') ? ' disabled' : '')}>
            ${item.parent().find('legend').html()}
            </div>`,
      html = '<div class="select select--single" >',
      end = '</div></div></div>',
      self = this;

    if (item.data('input')) {
      head = `<div class="select__arrow"></div><input placeholder="${item.parent().find('legend').text()}" 
                type="${(item.data('input-type') ? item.data('input-type') : 'text')}" 
                class="select-head searchbar" 
                data-text="${item.parent().find('legend').text()}" 
                autocomplete="off" 
                ${(item.attr('disabled') ? 'disabled' : '')}>`;
      item.parent().addClass('arrowed');
    }

    if (multi)
      html = '<div class="select select--multi" >';

    if (item.data('searchbar')) {
      html += '<div class="select__searchbar"><input type="text" class="searchbar" placeholder="Введите.."></div>';
      end = '</div></div><div class="select__buttons"><div class="btn btn-small btn-apply">Применить</div><div class="btn btn-reset btn-small btn-apply">Сбросить фильтр</div></div></div>';
    }

    html += '<div class="select-list-wrap"><div class="select-list">';
    html = head + html;
    html += self.addHtml(item);
    html += end;
    item.parent().find('.select-head, .select').remove();
    $(html).insertAfter(item);
    self.countElements(item.siblings('.select'), false, true);
    return this;
  }

  /**
   * @function
   * Make HTML list groups
   * @param {jQuery} item
   * @return {string} html of list
   */
  addHtml(item) {
    let childrens = item.children('option'),
      groups = item.children('optgroup'),
      html = '',
      self = this;

    childrens.each(function () {
      html += self.addOption($(this));
    });

    groups.each(function () {
      let checkbox = $(this).attr('data-checkbox') ? '<div class="checkmark"></div>' : '';
      let style = $(this).attr('data-checkbox') ? ' select-group--simple' : '';
      html += `<div class="select-group--head select__item${style}">${checkbox}${$(this).attr("label")}</div>`;
      html += '<div class="select-group">';
      html += self.addHtml($(this));
      html += '</div>';
    });

    return html;
  }

  /**
   * @function
   * Add option to select item
   * @param {jQuery} option
   * @return {string} html of option
   */
  addOption(option) {



    let selected = option.attr('selected') ? 'selected' : '',
      url = option.data('url') ? `data-url="${option.data('url')}" ` : '',
      checkmark = '<div class="checkmark__box"></div>',
      footnote = '';

    if (option.attr('data-check') === 'false') {
      checkmark = '';
      selected += ' select__item--nop';
    }
    else {
      selected += ' checkmark';
    }

    if (option.data('footnote'))
      footnote = `<br><span class="select__item-footnote">${option.data('footnote')}</span>`;

    return `<div class="select__item ${selected}" 
            ${url}
            data-value="${option.val()}">
            ${checkmark}
            ${option.html()}
            ${footnote}
            </div>`;
  }

  /**
   * @function
   * Bind events to Select object
   * @return {Select}
   */
  addEvents() {
    const selector = this.obj.attr('id');
    const self = this;

    $(document).on('click', '#' + selector + ' .select-head', function () {
      if ($(this).attr('disabled'))
        return;

      if (!$(this).hasClass('open')) {
        $(this).parents('form').find('.select, .arrowed, .select-head, .select__arrow').removeClass('open');
      }
      self.checkSelectPosition($(this));
      $(this).toggleClass('open');
      $(this).parent().find('.select__arrow').toggleClass('open');
      $(this).parent().find('.select').toggleClass('open');
      $(this).parents('.arrowed').eq(0).toggleClass('open');
    });

    $(document).on('click', '#' + selector + ' .select--single .select__item', function () {
      $(document).find('.select-head').attr('disabled', false);
      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');
        $(this).parents('.form-group').find('select').val('').trigger('change');
      } else {
        $(this).parents('.select').find('.selected').removeClass('selected');
        $(this).addClass('selected');
        $(this).parents('.form-group').find('select').val($(this).data('value')).trigger('change');

        const safeStorage = (() => {
          let supported = true;
          try {
            const testKey = '__ls_test';
            window.localStorage.setItem(testKey, testKey);
            window.localStorage.removeItem(testKey);
          } catch (e) {
            supported = false;
            console.warn('localStorage not available:', e);
          }

          return {
            getItem(key) {
              return supported ? window.localStorage.getItem(key) : null;
            },
            setItem(key, value) {
              if (!supported) return;
              try {
                window.localStorage.setItem(key, value)
              } catch { }
            },
            removeItem(key) {
              if (!supported) return;
              try {
                window.localStorage.removeItem(key)
              } catch { }
            }
          };
        })();


        safeStorage.setItem('mapCityId', $(this).parents('.form-group').find('select').val())
        window.dispatchEvent(new CustomEvent('mapCityIdChange', {
          detail: { value: $(this).parents('.form-group').find('select').val() }
        }));
      }

      $(this).parents('.form-group').find('.open').removeClass('open');
      self.countElements($(this).parents('.select'), true);

      for (const i of self.onchanges)
        self.onchanges[i]($(this), $(this).parents('.form-group').eq(0).children('select'));

      $(this).parents('.form-group').find('.select-head').removeClass('error');
      $(this).parents('.form-group').find('label.error').remove();
      $(this).parents('.select-head').attr('disabled', false);
    });

    $(document).on('click', '#' + selector + ' .select--multi .select__item', function () {
      let curValues = [];

      if ($(this).attr('data-value') === "")
        $(this).parents('.select').find('.selected').removeClass('selected');

      if ($(this).hasClass('select-group--head')) {
        if ($(this).hasClass('selected'))
          $(this).next().find('.select__item').removeClass('selected');
        else
          $(this).next().find('.select__item').addClass('selected');
      }

      $(this).toggleClass('selected');

      $(this).parents('.select').find('.selected').each(function (index, element) {
        if (!$(element).hasClass('select-group--head')) {
          curValues.push($(element).attr('data-value'));
        }
      });

      if ((curValues.indexOf('') + 1) && curValues.length > 1) {
        curValues.splice(curValues.indexOf(''), 1);
        $(this).parents('.select').find('[data-value=""]').removeClass('selected');
      }

      if ($(this).parent('.select-group').length) {
        if ($(this).parent('.select-group').children().length !== $(this).parent('.select-group').find('.selected').length)
          $(this).parent().prev().removeClass('selected');
        else
          $(this).parent().prev().addClass('selected');
      }

      $(this).parents('.form-group').find('select').val(curValues).change();
      self.countElements($(this).parents('.select'));

      $(this).parents('.form-group').find('.select-head').removeClass('error');
      $(this).parents('.form-group').find('label.error').remove();
    });

    $(document).on('click', '#' + selector + 'input:not(.searchbar):not(.select-head)', function () {
      $(this).parents('form').find('.select').removeClass('open');
      $(this).parents('form').find('.select-head').removeClass('open');
    });

    $(document).on('click', '#' + selector + ' input.searchbar', function () {
      $(this).parent().find('.select__item').show();
    });

    $(document).click(function (e) {
      let opened = $('body').find('#' + selector + ' .select-head.open');
      if (!opened.length)
        return;

      let target = $(e.target);
      if (!target.parents('#' + selector + ' .select').length &&
        !target.hasClass('open')) {
        opened.click();
      }
    });

    $(document).on('input', '#' + selector + ' .searchbar', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!$(this).hasClass('open'))
        $(this).click();
      let list = $(this).parents('.form-group').find('.select__item');
      let val = $(this).val().replace('(', '\\(').replace(')', '\\)').replace('.', '\\.').replace('\\', '\\\\');
      let regex = new RegExp(val, 'gi');
      let listLength = 0;

      list.each(function () {
        if ($(this).text().match(regex)) {
          listLength++;
          $(this).show();
        }
        else
          $(this).hide();
      });

      if (!listLength)
        $(this).parent().find('.select').hide();
      else
        $(this).parent().find('.select').show();
    });

    $(window).trigger('resize');

    this.obj.find('.select-list').each(function () {
      self.checkSelectVal($(this));
    });
    return this;
  }

  /**
   * @function
   * Update select value
   * @param {jQuery} item
   * @return {Select}
   */
  checkSelectVal(item) {
    let selected = 0;
    item.find('.select__item').each(function () {
      if ($(this).hasClass('selected'))
        selected++;
    });

    if (!selected)
      item.parents('.form-group').find('select').val([]);
    return this;
  }

  /**
   * @function
   * Update select list position
   * depends on screen availability
   * @param {jQuery} item
   * @return {Select}
   */
  checkSelectPosition(item) {
    const screenHeight = $('body').innerHeight,
      group = item.parents('.form-group'),
      topOffset = group.offset().top + group.height();

    if (screenHeight - topOffset < group.find('.select').get(0).scrollHeight)
      group.find('.select').addClass('select--top');
    else
      group.find('.select').removeClass('select--top');
    return this;
  }

  /**
   * @function
   * Set text for select head
   * @param {jQuery} item
   * @param {boolean} isSingle
   * @param {boolean} isFirst is it FIRST set for text
   * @return {Select}
   */
  countElements(item, isSingle, isFirst) {
    let selected = item.find('.selected:not(.select-group--head)'),
      count = selected.length,
      head = item.parents('.form-group').find('.select-head'),
      substrLength = selected.find('.select__item-footnote').text().length,
      isInput = head.hasClass('searchbar'),
      text = '',
      footnote = item.parents('.form-group').find('select').data('footnote');

    if (isFirst) {
      if (!empty(selected.data('value'))) {
        if (count > 1)
          head.text('Выбрано ' + count);
        else {
          if (head[0].tagName === 'INPUT')
            head.val(selected.text().trim());
          else
            head.html(((typeof footnote === 'undefined') ? '' : '<span class="footnote">' + footnote + '</span>') + selected.text().substr(0, selected.text().length - substrLength).trim());
        }
      }
      else {
        text = selected.length
          ? (selected.data('value') === ''
            ? head.data('text')
            : selected.text().substr(0, selected.text().length - substrLength))
          : head.data('text');

        head.html(((typeof footnote === 'undefined') ? '' : '<span class="footnote">' + footnote + '</span>') + text);
      }
    } else if (isSingle) {
      if (count && selected.data('value') !== '') {
        text = selected.text().substr(0, selected.text().length - substrLength).trim();

        if (isInput) {
          if (head.attr('type') === 'number' && text.match(/\D/g))
            head.prop('value', '');
          else head.val(text);
        }
        else
          head.html(((typeof footnote === 'undefined') ? '' : '<span class="footnote">' + footnote + '</span>') + text);
      } else {
        text = head.data('text').trim();

        if (isInput) {
          if (head.attr('type') === 'number' && text.match(/\D/g))
            head.prop('value', '');
          else head.val(text);
        }
        else
          head.html(((typeof footnote === 'undefined') ? '' : '<span class="footnote">' + footnote + '</span>') + text);
      }
    } else if (count === 1) {
      if (selected.data('value') === '') {
        text = head.data('text');
        if (isInput) {
          if (head.attr('type') === 'number' && text.match(/\D/g))
            head.prop('value', '');
          else head.val(text);
        }
        else
          head.html(((typeof footnote === 'undefined') ? '' : '<span class="footnote">' + footnote + '</span>') + text);
      } else {
        text = selected.text().substr(0, selected.text().length - substrLength).trim();
        if (isInput) {
          if (head.attr('type') === 'number' && text.match(/\D/g))
            head.prop('value', '');
          else head.val(text);
        }
        else
          head.html(((typeof footnote === 'undefined') ? '' : '<span class="footnote">' + footnote + '</span>') + text);
      }
    } else if (count > 1) {
      head.text('Выбрано ' + count);
    } else {
      head.text(head.data('text'));
      item.parent().find('[data-value=""]').addClass('selected');
    }
    return this;
  }

  /**
   * @function
   * Add initialized classes for Select
   * @return {Select}
   */
  addClasses() {
    this.obj.addClass('initialized');
    this.select.addClass('initialized');
    this.multiSelect.addClass('initialized');
    this.select.find('.select__item').addClass('initialized');
    this.multiSelect.find('.select__item').addClass('initialized');
    this.obj.find('.none').removeClass('none');
    return this;
  }

  /**
   * @function
   * Set onchange function
   * @param {function} func
   */
  onChange(func) {
    this.onchanges.push(func);
  }
}

window.Select = Select;

export default Select;
